import styled, { keyframes } from "styled-components";

const frames = keyframes`
0% {
    top: 0em;
  }
  40% {
    top: 0em;
  }
  43% {
    top: -0.9em;
  }
  46% {
    top: 0em;
  }
  48% {
    top: -0.4em;
  }
  50% {
    top: 0em;
  }
  100% {
    top: 0em;
  }
`;

interface JumpBtnProps {
    borderColor: string;
    colorOnHover: string;
    backgroundColor?: string;
    value?: string;
    onClick?: Function;
    disabled?: boolean;
    style?: React.CSSProperties;
}

const StyledInput = styled.input<JumpBtnProps>`
    display: inline-block;
    padding: 0.65em 1.6em;
    border: 3px solid
        ${(props) => (props.disabled ? "#4e4e4e" : props.borderColor)};
    margin: 0.3em 0.3em 0.3em 0.3em;
    border-radius: 0.12em;
    box-sizing: border-box;
    text-decoration: none;
    font-family: "Roboto", sans-serif;
    font-weight: 300;
    color: black;
    text-align: center;
    transition: all 0.2s;
    animation: ${frames} 5s infinite linear;
    position: relative;
    border-radius: 2vw;
    background-color: ${(props) =>
        props.backgroundColor ? props.backgroundColor : "transparent"};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

    &:hover {
        background-color: ${(props) =>
            props.disabled ? undefined : props.colorOnHover};
        color: ${(props) => (props.disabled ? "grey" : "white")};
    }
`;

const JumpBtn: React.FC<JumpBtnProps> = ({
    borderColor,
    colorOnHover,
    value,
    onClick,
    disabled,
    style,
    backgroundColor,
}) => {
    return (
        <StyledInput
            type="button"
            borderColor={borderColor}
            colorOnHover={colorOnHover}
            backgroundColor={backgroundColor}
            value={value}
            onClick={() => onClick && onClick()}
            disabled={disabled}
            style={{
                ...style,
            }}
        />
    );
};

export default JumpBtn;
